const COLORS = {
    red: "red",
    gray: "gray",
    blue: "blue",
    orange: "orange",
    green: "green",
    brown: "brown",
    pink: "pink",
    purple: "purple",
    teal: "teal",
    yellow: "yellow",
    osuGray: "osuGray",
    indigo: "indigo",
    offwhite: "offwhite",
    darkGreen: "darkGreen",
    seafoam: "seafoam"
}

let darkModeColor = {
    [COLORS.red]: "#F66582",
    [COLORS.gray]: "#A7B1B7",
    [COLORS.blue]: "#A0DBF3",
    [COLORS.orange]: "#FFB59C",
    [COLORS.brown]: "#CAB09B",
    [COLORS.green]: "#C7EEB2",
    [COLORS.seafoam]: "#9AD0C4",
    [COLORS.teal]: "#BED2D3",
    [COLORS.purple]: "#CD99C1",
    [COLORS.pink]: "#FDB1BF",
    [COLORS.darkGreen]: "#8edd65",
    [COLORS.yellow]: "#FFDB80",
    [COLORS.osuGray]: "#A7B1B7"
}

let standardColor = {
    [COLORS.red]: "#BA0C2F",
    [COLORS.osuGray]: "#A7B1B7",
    [COLORS.gray]: "#A7B1B7",
    [COLORS.blue]: "#41b6e6",
    [COLORS.orange]: "#ff6a39",
    [COLORS.green]: "#8EDD65",
    [COLORS.brown]: "#764D2C",
    [COLORS.pink]: "#fb637e",
    [COLORS.purple]: "#830065",
    [COLORS.seafoam]: "#6ebbab",
    [COLORS.teal]: "#225E62",
    [COLORS.yellow]: "#ffb600",
    [COLORS.darkGreen]: "#395828"
}

const brandColor = {
    scarlet: {
        main: "#BA0C2F",
        40: "#70071c",
        60: "#4a0513"
    },
    gray: {
        main: "#A7B1B7",
        lighter: {
            20: "#bfc6cb",
            40: "#cfd4d8",
            60: "#dfe3e5",
            80: "#eff1f2",
        },
        darker: {
            20: "#868e92",
            40: "#646a6e",
            60: "#3f4443",
            80: "#212325",
        }
    }
}

export const typeColor = {
    standard: {
        action: "#215B73",
        primary: "#215B73",
        secondary: brandColor.gray.darker[60],
        default: "#000000",
        error: standardColor.red
    },
    darkMode: {
        action: darkModeColor.blue,
        primary: darkModeColor.gray,
        secondary: darkModeColor.gray,
        default: "#ffffff",
        error: darkModeColor.red
    }
}

export const rootDarkColor = 'var(--elevation0)'

export {
    COLORS,
    standardColor,
    darkModeColor,
    brandColor
}
